import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Loader, DefaultError } from 'components';

class CustomLoader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  errorRenderer = () => <DefaultError />;

  render() {
    const { background, error, pastDelay, timedOut, isLoading } = this.props;
    if (error && !isLoading) {
      return this.errorRenderer();
    } else if (timedOut) {
      return this.errorRenderer();
    } else if (isLoading && pastDelay) {
      return <Loader background={background} />;
    }
    return null;
  }
}

CustomLoader.propTypes = {
  background: PropTypes.bool,
  error: PropTypes.any,
  timedOut: PropTypes.bool,
  pastDelay: PropTypes.bool,
  isLoading: PropTypes.bool,
};

CustomLoader.defaultProps = {
  error: null,
  background: true,
  timedOut: false,
  pastDelay: false,
  isLoading: false,
};

export default CustomLoader;
